<template lang="pug">
.wagtail-rich-text-quote(v-html="value")
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.wagtail-rich-text-quote {
    margin-left: 90px;
    padding-left: 20px;
    border-left: 4px solid $primary;
    color: $primary;

    @include mobile {
        margin-left: 0px;
    }

    p {
        margin-bottom: 30px;
        font-size: 16px;
        color: $primary;
    }
    h1, h2, h3, h4 {
        color: $primary;
        margin-bottom: 30px;
    }
}
</style>